import React from "react";

const DemoTeamSummary = ({
  companyName,
  numberSeats,
  selectedPlanInterval,
  leadsNumber,
  isPriceMonthly,
  isCustomPricing,
  pricePerSeatYearlyDollars,
  customBucketDiscount,
  offerFreeTrial,
  trialDate,
  csvImportEnrichment,
}) => (
  <div className="stripeCustomerContainer">
    <h4>Summary</h4>
    <p>Company Name: {companyName}</p>
    <p>Number of Seats: {numberSeats}</p>
    <p>Number of leads: {leadsNumber}</p>
    <p>Plan Interval: {selectedPlanInterval.label} </p>
    {csvImportEnrichment && <p>CSV Import Enrichment: Yes</p>}
    {!isPriceMonthly && (
      <>
        <p>Custom Pricing: {isCustomPricing ? "Yes" : "No"}</p>
        {isCustomPricing && <p>Price Per Seat Per {selectedPlanInterval.intervalCount} {selectedPlanInterval.intervalCount === 1 ? selectedPlanInterval.interval : `${selectedPlanInterval.interval}s`}: ${pricePerSeatYearlyDollars}</p>}
        {isCustomPricing && <p>Bucket Discount: {customBucketDiscount}%</p>}
      </>
    )}
    <p>
      Free Trial:{" "}
      {offerFreeTrial ? `Yes (${isPriceMonthly ? "1 month" : `until ${trialDate}`})` : "No"}
    </p>
  </div>
);

export default DemoTeamSummary;
